export function isSpecialDefaultGallection(gallection) {
    if ((gallection === null || gallection === void 0 ? void 0 : gallection.type) === 'private_collection') {
        return gallection.name === 'Private';
    }
    return (gallection === null || gallection === void 0 ? void 0 : gallection.name) === 'Featured';
}
